import { IWorkOrderGridRow } from 'Data/ReduxViewModels/Ags/WorkOrderGrid/types';
import React from 'react';
import { NavLink } from 'react-router-dom';

interface IWorkOrderGridRowProps {
  rowData: IWorkOrderGridRow;
}

const WorkOrderListItem: React.FC<IWorkOrderGridRowProps> = ({ rowData }) => {
  const workOrderUrl = `/ags/workorders/${rowData.WorkOrderUuid}`;

  return (
    <li>
      <NavLink to={workOrderUrl}>
        <b>{rowData.WorkOrderId}</b> ({rowData.ProjectCode} - {rowData.ProjectName})
      </NavLink>
    </li>
  );
};

export { WorkOrderListItem };
export default WorkOrderListItem;
